/** Responsive grid span props for the sidebar column (filters). */
export const SIDEBAR_GRID_SPANS = {
  span: 2,
  spanLg: 3,
  spanMd: 3,
  spanSm: 4,
  spanXl: 2,
  spanXs: null,
} as const

/** Responsive grid span props for the main content column. */
export const MAIN_GRID_SPANS = {
  span: 10,
  spanLg: 9,
  spanMd: 9,
  spanSm: 8,
  spanXl: 10,
  spanXs: 12,
} as const

/** Responsive grid offset props for the main content column (used when sidebar is absent). */
export const MAIN_GRID_OFFSETS = {
  offset: 2,
  offsetLg: 3,
  offsetMd: 3,
  offsetSm: 4,
  offsetXl: 2,
} as const
